import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode, isRef as _isRef, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/logo.png",
  width: "247",
  height: "84",
  alt: "プレチェク",
  style: {"height":"54px","width":"auto","vertical-align":"middle"}
}, null, -1)
const _hoisted_2 = {
  key: 1,
  href: "/"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/logo.png",
  width: "247",
  height: "84",
  alt: "プレチェク",
  style: {"height":"54px","width":"auto","vertical-align":"middle"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "row items-center q-gutter-sm q-pr-lg"
}
const _hoisted_6 = { class: "q-mr-md text-primary flex items-center" }
const _hoisted_7 = { class: "q-mr-md text-primary" }
const _hoisted_8 = { class: "q-pa-sm column q-gutter-sm text-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Copyright(c) 2021 Tryit Co., Ltd All Rights Reserved.", -1)

import { useToggle, useLogout } from '@/composables'
import { useUserStore } from '@/stores'

/** ユーザーデータ */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore()

/** ログアウト */
const { logout } = useLogout()

/** ドロワー */
const { value: isOpenRightDrawer, toggle: toggleRightDrawer } = useToggle(false)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: _ctx.$q.screen.lt.md ? 'hHr lpr ffr' : 'hHh lpr fff'
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        reveal: "",
        bordered: "",
        class: "bg-grey-1 text-dark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => [
                  (_unref(userStore).data)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/mypage"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("a", _hoisted_2, _hoisted_4))
                ]),
                _: 1
              }),
              (_ctx.$q.screen.lt.md)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    dense: "",
                    flat: "",
                    round: "",
                    icon: "menu",
                    onClick: _unref(toggleRightDrawer)
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(userStore).data)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_q_icon, {
                              name: "person",
                              style: {"font-size":"1.9em","margin-right":"3px"}
                            }),
                            _createElementVNode("div", null, _toDisplayString(_unref(userStore).data.userSect), 1)
                          ]),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(userStore).data.userName) + " 様", 1),
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            rounded: "",
                            color: "primary",
                            to: "mypage",
                            label: "マイページ"
                          }),
                          _createVNode(_component_q_btn, {
                            outline: "",
                            rounded: "",
                            color: "primary",
                            onClick: _unref(logout),
                            label: "ログアウト"
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_drawer, {
        modelValue: _unref(isOpenRightDrawer),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isOpenRightDrawer) ? (isOpenRightDrawer).value = $event : null)),
        side: "right",
        overlay: "",
        bordered: "",
        "no-swipe-open": "",
        "no-swope-close": "",
        "no-swipe-backdrop": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_scroll_area, { class: "fit" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (_unref(userStore).data)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_icon, {
                          name: "person",
                          style: {"font-size":"1.9em","margin-right":"3px"}
                        }),
                        _createTextVNode(_toDisplayString(_unref(userStore).data.userSect), 1)
                      ]),
                      _createElementVNode("div", null, _toDisplayString(_unref(userStore).data.userName) + " 様", 1),
                      _createVNode(_component_q_btn, {
                        color: "primary",
                        to: "mypage",
                        label: "マイページ"
                      }),
                      _createVNode(_component_q_btn, {
                        color: "primary",
                        outline: "",
                        onClick: _unref(logout),
                        label: "ログアウト"
                      }, null, 8, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_page, {
            class: "q-mx-auto q-pa-md",
            style: {"max-width":"var(--q-size-md)"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_footer, {
        bordered: "",
        class: "bg-grey-1 text-dark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "justify-center" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["view"]))
}
}

})